import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1864ade6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1864ade6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1864ade6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1864ade6')) {
      api.createRecord('1864ade6', component.options)
    } else {
      api.reload('1864ade6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1864ade6&scoped=true", function () {
      api.rerender('1864ade6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CRMImport/index.vue"
export default component.exports